import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import WhatsAppButton from '../components/WhatsAppButton';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

/* ── Partículas flutuantes ── */
function Particles() {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current; if (!c) return;
    const ctx = c.getContext('2d');
    let W = c.width = c.offsetWidth, H = c.height = c.offsetHeight, raf;
    const pts = Array.from({ length: 60 }, () => ({
      x: Math.random() * W, y: Math.random() * H,
      r: Math.random() * 2.5 + 0.5,
      vx: (Math.random() - 0.5) * 0.25,
      vy: -(Math.random() * 0.35 + 0.1),
      o: Math.random() * 0.45 + 0.1,
      h: Math.random() > 0.5 ? 142 : 44,
    }));
    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      pts.forEach(p => {
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `hsla(${p.h},65%,65%,${p.o})`; ctx.fill();
        p.x += p.vx; p.y += p.vy;
        if (p.y < -8) { p.y = H + 8; p.x = Math.random() * W; }
        if (p.x < -8) p.x = W + 8; if (p.x > W + 8) p.x = -8;
      });
      raf = requestAnimationFrame(draw);
    };
    draw();
    const onR = () => { W = c.width = c.offsetWidth; H = c.height = c.offsetHeight; };
    window.addEventListener('resize', onR);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', onR); };
  }, []);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full pointer-events-none" style={{ mixBlendMode: 'screen' }} />;
}

/* ── Contador animado ── */
function Counter({ to = 0, prefix = '', suffix = '' }) {
  const [v, setV] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !to) return;
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      let cur = 0;
      const step = Math.max(1, Math.ceil(to / 60));
      const t = setInterval(() => { cur += step; if (cur >= to) { setV(to); clearInterval(t); } else setV(cur); }, 20);
      obs.disconnect();
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [to]);
  return <span ref={ref}>{prefix}{v.toLocaleString('pt-BR')}{suffix}</span>;
}

/* ── Badge de avaliação ── */
function Stars({ n = 5 }) {
  return <span className="text-acre-gold text-sm">{'★'.repeat(n)}</span>;
}

const STATS_DEFAULT = [
  { n: 0, l: 'Candidatos cadastrados', icon: '👤', suffix: '+' },
  { n: 0, l: 'Empresas parceiras',     icon: '🏢', suffix: '+' },
  { n: 0, l: 'Vagas abertas',          icon: '💼', suffix: '' },
  { n: 22, l: 'Municípios do Acre',    icon: '📍', suffix: '' },
];

const FEATURES = [
  { icon: '🤖', color: 'from-violet-500 to-purple-600', t: 'Mikhal — IA', d: 'Crie seu perfil completo em minutos conversando com nossa IA. Zero formulário, tudo pelo chat.' },
  { icon: '💚', color: 'from-emerald-500 to-teal-600',  t: 'Match Tinder', d: 'Deslize para encontrar a vaga ou candidato ideal. Algoritmo de compatibilidade em tempo real.' },
  { icon: '💬', color: 'from-blue-500 to-cyan-600',     t: 'Chat Direto',  d: 'Converse diretamente com empresas ou candidatos quando o match for ≥ 80%.' },
  { icon: '🎯', color: 'from-orange-500 to-red-500',    t: 'Match por IA', d: 'Calculamos o % de compatibilidade por área, cidade, experiência e escolaridade.' },
  { icon: '📲', color: 'from-green-500 to-lime-600',    t: 'PIX Integrado', d: 'Pagamento instantâneo via PIX com QR Code automático. Acesso liberado em até 24h.' },
  { icon: '⚡', color: 'from-yellow-500 to-amber-600',  t: 'Tempo Real',   d: 'Vagas e candidatos atualizados em tempo real. Nunca perca uma oportunidade.' },
];

const DEPOS = [
  { nome: 'Ana Paula S.', cargo: 'Analista de RH', empresa: 'Empresa de TI · Rio Branco', txt: 'Encontramos 3 candidatos excelentes em menos de uma semana. O sistema de match facilita muito o processo seletivo.', av: 5 },
  { nome: 'Carlos M.',    cargo: 'Desenvolvedor',  empresa: 'Candidato · Cruzeiro do Sul', txt: 'Consegui meu emprego em 12 dias! O chat integrado foi fundamental para negociar direto com a empresa.', av: 5 },
  { nome: 'Fernanda L.',  cargo: 'Gerente de RH',  empresa: 'Comércio · Sena Madureira',   txt: 'A Mikhal IA ajudou nossos candidatos a montar currículos muito melhores. Qualidade das candidaturas aumentou muito.', av: 5 },
];

const MUNS = ['Rio Branco','Cruzeiro do Sul','Sena Madureira','Tarauacá','Feijó','Brasileia','Xapuri','Senador Guiomard','Acrelândia','Plácido de Castro','Mâncio Lima','Rodrigues Alves'];

export default function Landing() {
  const [stats, setStats] = useState(null);
  const [tab, setTab] = useState('candidato'); // hero tab

  const carregarStats = () => {
    fetch(`${API}/dados/stats`)
      .then(r => r.ok ? r.json() : null)
      .then(d => d && setStats(d))
      .catch(() => {});
  };

  useEffect(() => {
    carregarStats();
    // Auto-atualiza a cada 30 segundos
    const iv = setInterval(carregarStats, 30000);
    return () => clearInterval(iv);
  }, []);

  const realStats = STATS_DEFAULT.map((s, i) => ({
    ...s,
    n: [
      Number(stats?.candidatos)  || 0,
      Number(stats?.empresas)    || 0,
      Number(stats?.vagas_abertas) || 0,
      22,
    ][i],
  }));

  return (
    <div className="min-h-screen bg-[#f9fafb] overflow-x-hidden">
      <Navbar />
      <WhatsAppButton />

      {/* ═══════════════════════════════════════
          HERO
      ═══════════════════════════════════════ */}
      <section className="relative bg-acre-dark min-h-[600px] flex flex-col justify-center overflow-hidden">
        {/* Fundo gradiente animado */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a1f12] via-[#0f2318] to-[#1a3820]" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[500px] bg-acre-green/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 right-0 w-[500px] h-[400px] bg-acre-gold/8 rounded-full blur-3xl" />
        <Particles />

        <div className="relative z-10 max-w-6xl mx-auto px-5 py-20 md:py-28 w-full">
          {/* Badge */}
          <div className="flex justify-center mb-8">
            <span className="inline-flex items-center gap-2 bg-acre-gold/15 text-acre-gold border border-acre-gold/25 text-xs font-bold px-5 py-2 rounded-full tracking-wide">
              🌿 Plataforma Nº1 de Empregos no Acre
            </span>
          </div>

          {/* Título */}
          <h1 className="font-sora text-4xl md:text-6xl font-extrabold text-white text-center leading-tight mb-4">
            Seu próximo passo<br />
            <span className="bg-gradient-to-r from-acre-gold to-yellow-300 bg-clip-text text-transparent">
              começa aqui
            </span>
          </h1>
          <p className="text-white/60 text-center text-lg md:text-xl mb-12 max-w-xl mx-auto">
            IA, Match Tinder e Chat integrado para conectar talentos e empresas em todo o Acre.
          </p>

          {/* Cards de escolha — Candidato / Empresa */}
          <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto">
            {/* Candidato */}
            <Link to="/cadastro?tipo=candidato"
              className="group relative bg-white/5 hover:bg-white/10 border border-white/10 hover:border-acre-green/60 rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-acre-green/20 cursor-pointer">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center text-2xl shadow-lg">
                  👤
                </div>
                <div>
                  <p className="font-sora font-bold text-white text-lg">Sou Candidato</p>
                  <span className="text-xs font-semibold text-emerald-400 bg-emerald-400/10 px-2 py-0.5 rounded-full">100% Gratuito</span>
                </div>
              </div>
              <ul className="space-y-2 mb-6">
                {['Crie seu currículo com IA em minutos','Match automático com vagas da sua área','Chat direto com as empresas','Acesso a +300 vagas abertas agora'].map((i, k) => (
                  <li key={k} className="flex items-center gap-2 text-white/70 text-sm">
                    <span className="w-4 h-4 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
                      <svg className="w-2.5 h-2.5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/></svg>
                    </span>
                    {i}
                  </li>
                ))}
              </ul>
              <div className="flex items-center justify-between">
                <span className="font-sora font-bold text-white text-sm">Criar perfil grátis</span>
                <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center group-hover:bg-emerald-400 transition-colors">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7"/>
                  </svg>
                </div>
              </div>
            </Link>

            {/* Empresa */}
            <Link to="/cadastro?tipo=empresa"
              className="group relative bg-white/5 hover:bg-white/10 border border-white/10 hover:border-acre-gold/60 rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-acre-gold/20 cursor-pointer">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-500 to-yellow-500 flex items-center justify-center text-2xl shadow-lg">
                  🏢
                </div>
                <div>
                  <p className="font-sora font-bold text-white text-lg">Sou Empresa</p>
                  <span className="text-xs font-semibold text-amber-400 bg-amber-400/10 px-2 py-0.5 rounded-full">15 dias grátis</span>
                </div>
              </div>
              <ul className="space-y-2 mb-6">
                {['Publique vagas e receba candidatos hoje','IA rankeia candidatos por compatibilidade','Agende entrevistas direto pelo chat','Pague só após encontrar o candidato certo'].map((i, k) => (
                  <li key={k} className="flex items-center gap-2 text-white/70 text-sm">
                    <span className="w-4 h-4 rounded-full bg-amber-500/20 flex items-center justify-center flex-shrink-0">
                      <svg className="w-2.5 h-2.5 text-amber-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/></svg>
                    </span>
                    {i}
                  </li>
                ))}
              </ul>
              <div className="flex items-center justify-between">
                <span className="font-sora font-bold text-white text-sm">Cadastrar empresa</span>
                <div className="w-8 h-8 rounded-full bg-amber-500 flex items-center justify-center group-hover:bg-amber-400 transition-colors">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7"/>
                  </svg>
                </div>
              </div>
            </Link>
          </div>

          {/* Link vagas */}
          <p className="text-center mt-6 text-white/40 text-sm">
            Só quer explorar?{' '}
            <Link to="/vagas" className="text-acre-gold hover:underline font-medium">Ver vagas abertas →</Link>
          </p>
        </div>

        {/* Stats bar */}
        <div className="relative z-10 border-t border-white/10 bg-black/30 backdrop-blur-md">
          <div className="max-w-4xl mx-auto px-5 py-5 grid grid-cols-2 md:grid-cols-4 gap-4">
            {realStats.map((s, i) => (
              <div key={i} className="text-center">
                <p className="font-sora text-2xl font-extrabold text-white">
                  <Counter to={s.n} suffix={s.suffix} />
                </p>
                <p className="text-white/45 text-xs mt-0.5">{s.icon} {s.l}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          FUNCIONALIDADES
      ═══════════════════════════════════════ */}
      <section className="py-20 px-5 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14">
            <span className="text-acre-green text-xs font-bold uppercase tracking-widest">Plataforma completa</span>
            <h2 className="font-sora text-3xl md:text-4xl font-extrabold text-acre-dark mt-2 mb-3">
              Tecnologia que faz a diferença
            </h2>
            <p className="text-gray-400 max-w-md mx-auto">Ferramentas modernas para simplificar recrutamento e busca de emprego no Acre</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {FEATURES.map(f => (
              <div key={f.t} className="group bg-[#f9fafb] hover:bg-white border border-gray-100 hover:border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${f.color} flex items-center justify-center text-2xl shadow-md mb-4 group-hover:scale-110 transition-transform`}>
                  {f.icon}
                </div>
                <h3 className="font-sora font-bold text-acre-dark text-base mb-2">{f.t}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          COMO FUNCIONA — TABS
      ═══════════════════════════════════════ */}
      <section className="py-20 px-5 bg-gradient-to-br from-acre-light via-white to-acre-light">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-acre-green text-xs font-bold uppercase tracking-widest">Simples e rápido</span>
            <h2 className="font-sora text-3xl md:text-4xl font-extrabold text-acre-dark mt-2">Como funciona</h2>
          </div>

          {/* Tab switcher */}
          <div className="flex gap-2 p-1.5 bg-white rounded-2xl shadow-sm border border-gray-100 max-w-xs mx-auto mb-10">
            <button onClick={() => setTab('candidato')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all ${tab === 'candidato' ? 'bg-acre-green text-white shadow-md' : 'text-gray-400 hover:text-acre-dark'}`}>
              👤 Candidato
            </button>
            <button onClick={() => setTab('empresa')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all ${tab === 'empresa' ? 'bg-acre-gold text-acre-dark shadow-md' : 'text-gray-400 hover:text-acre-dark'}`}>
              🏢 Empresa
            </button>
          </div>

          {tab === 'candidato' && (
            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="bg-gradient-to-r from-acre-green to-teal-600 px-8 py-6 flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center text-3xl">👤</div>
                <div>
                  <h3 className="font-sora font-extrabold text-white text-xl">Para Candidatos</h3>
                  <span className="text-emerald-200 text-sm">100% gratuito — sem cartão de crédito</span>
                </div>
              </div>
              <div className="p-8">
                <div className="grid sm:grid-cols-2 gap-5 mb-8">
                  {[
                    { n: '01', t: 'Cadastro rápido', d: 'Crie sua conta em 2 minutos com nome, e-mail e cidade.', icon: '✍️' },
                    { n: '02', t: 'Converse com Mikhal', d: 'Nossa IA monta seu currículo completo pelo chat. Sem formulários.', icon: '🤖' },
                    { n: '03', t: 'Match Tinder', d: 'Veja vagas compatíveis e deslize para demonstrar interesse.', icon: '💚' },
                    { n: '04', t: 'Seja contratado', d: 'Converse com a empresa e agende entrevista direto pelo chat.', icon: '🎉' },
                  ].map(s => (
                    <div key={s.n} className="flex gap-4">
                      <div className="w-10 h-10 rounded-xl bg-acre-light flex items-center justify-center text-xl flex-shrink-0">{s.icon}</div>
                      <div>
                        <p className="font-sora font-bold text-acre-dark text-sm">{s.t}</p>
                        <p className="text-gray-400 text-xs mt-0.5 leading-relaxed">{s.d}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <Link to="/cadastro?tipo=candidato" className="btn-primary w-full justify-center text-base py-3.5 flex items-center gap-2">
                  Criar perfil grátis agora
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>
                </Link>
              </div>
            </div>
          )}

          {tab === 'empresa' && (
            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="bg-gradient-to-r from-amber-500 to-yellow-500 px-8 py-6 flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center text-3xl">🏢</div>
                <div>
                  <h3 className="font-sora font-extrabold text-acre-dark text-xl">Para Empresas</h3>
                  <span className="text-yellow-900/70 text-sm">15 dias grátis · Pague só no resultado</span>
                </div>
              </div>
              <div className="p-8">
                <div className="grid sm:grid-cols-2 gap-5 mb-8">
                  {[
                    { n: '01', t: 'Cadastre sua empresa', d: 'Adicione logo, CNPJ e área de atuação com ajuda da Mikhal IA.', icon: '🏢' },
                    { n: '02', t: 'Publique suas vagas', d: 'Crie vagas detalhadas e receba candidatos rankeados por % de match.', icon: '📋' },
                    { n: '03', t: 'Selecione os melhores', d: 'Agende videochamadas, entrevistas e registre resultados na plataforma.', icon: '🎯' },
                    { n: '04', t: 'Pague via PIX', d: 'QR Code automático. Acesso ativo em até 24h após confirmação.', icon: '📲' },
                  ].map(s => (
                    <div key={s.n} className="flex gap-4">
                      <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center text-xl flex-shrink-0">{s.icon}</div>
                      <div>
                        <p className="font-sora font-bold text-acre-dark text-sm">{s.t}</p>
                        <p className="text-gray-400 text-xs mt-0.5 leading-relaxed">{s.d}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <Link to="/cadastro?tipo=empresa" className="btn-gold w-full justify-center text-base py-3.5 flex items-center gap-2">
                  Cadastrar empresa agora
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ═══════════════════════════════════════
          DEPOIMENTOS
      ═══════════════════════════════════════ */}
      <section className="py-20 px-5 bg-acre-dark overflow-hidden relative">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a1f12] to-[#1a3820]" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-acre-green/10 rounded-full blur-3xl" />
        <div className="relative z-10 max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-acre-gold text-xs font-bold uppercase tracking-widest">Quem já usa</span>
            <h2 className="font-sora text-3xl font-extrabold text-white mt-2">O que dizem sobre nós</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {DEPOS.map((d, i) => (
              <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/8 transition-all">
                <Stars n={d.av} />
                <p className="text-white/75 text-sm leading-relaxed mt-3 mb-5">"{d.txt}"</p>
                <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-acre-green to-teal-600 flex items-center justify-center text-white font-bold text-sm">
                    {d.nome[0]}
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{d.nome}</p>
                    <p className="text-white/40 text-xs">{d.empresa}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          MUNICÍPIOS
      ═══════════════════════════════════════ */}
      <section className="py-16 px-5 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-acre-green text-xs font-bold uppercase tracking-widest">Cobertura total</span>
          <h2 className="font-sora text-2xl font-extrabold text-acre-dark mt-2 mb-8">
            🗺️ Atendemos todo o Acre
          </h2>
          <div className="flex flex-wrap gap-2 justify-center">
            {MUNS.map(m => (
              <span key={m} className="inline-flex items-center gap-1.5 bg-acre-light text-acre-green border border-acre-green/20 text-xs font-semibold px-3.5 py-1.5 rounded-full hover:bg-acre-green hover:text-white transition-colors cursor-default">
                📍 {m}
              </span>
            ))}
            <span className="inline-flex items-center gap-1.5 bg-gray-100 text-gray-400 text-xs font-semibold px-3.5 py-1.5 rounded-full">
              +10 municípios
            </span>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          CTA FINAL
      ═══════════════════════════════════════ */}
      <section className="py-20 px-5 bg-gradient-to-br from-acre-green via-[#1a6b45] to-teal-700 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PHBhdGggZD0iTTM2IDM0djZoNnYtNmgtNnptNiAwaC02di02aDZ2NnoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-40" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-white/5 rounded-full blur-3xl" />
        <div className="relative z-10 text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white text-xs font-bold px-4 py-2 rounded-full mb-6">
            🚀 Comece hoje mesmo
          </div>
          <h2 className="font-sora text-4xl md:text-5xl font-extrabold text-white leading-tight mb-4">
            Seu emprego ideal<br />está a um match de distância
          </h2>
          <p className="text-white/70 text-lg mb-10">
            Candidatos entram grátis. Empresas têm 15 dias para testar sem compromisso.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/cadastro?tipo=candidato"
              className="group bg-acre-gold hover:bg-yellow-400 text-acre-dark font-extrabold px-10 py-4 rounded-2xl text-lg transition-all shadow-2xl shadow-black/30 hover:scale-105 flex items-center justify-center gap-2">
              👤 Sou Candidato — Grátis
            </Link>
            <Link to="/cadastro?tipo=empresa"
              className="group bg-white/10 hover:bg-white/20 border-2 border-white/30 hover:border-white/50 text-white font-extrabold px-10 py-4 rounded-2xl text-lg transition-all flex items-center justify-center gap-2">
              🏢 Sou Empresa
            </Link>
          </div>
          <p className="text-white/40 text-xs mt-6">Sem cartão de crédito · Sem taxa de adesão · Cancel a qualquer hora</p>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          FOOTER
      ═══════════════════════════════════════ */}
      <footer className="bg-[#050e08] py-8 px-5">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-5">
            <div className="flex items-center gap-2">
              <span className="text-2xl">🌿</span>
              <span className="font-sora font-bold text-xl text-white">Acre<span className="text-acre-gold">Job</span></span>
            </div>
            <div className="flex flex-wrap justify-center gap-6">
              <Link to="/vagas"                  className="text-white/30 hover:text-white/70 text-xs transition-colors">Ver Vagas</Link>
              <Link to="/quem-somos"             className="text-white/30 hover:text-white/70 text-xs transition-colors">Quem Somos</Link>
              <Link to="/como-funciona"          className="text-white/30 hover:text-white/70 text-xs transition-colors">Como Funciona</Link>
              <Link to="/contato"                className="text-white/30 hover:text-white/70 text-xs transition-colors">Contato</Link>
              <Link to="/termos-uso"             className="text-white/30 hover:text-white/70 text-xs transition-colors">Termos de Uso</Link>
              <Link to="/politica-privacidade"   className="text-white/30 hover:text-white/70 text-xs transition-colors">Política de Privacidade</Link>
              <Link to="/login"                  className="text-white/30 hover:text-white/70 text-xs transition-colors">Entrar</Link>
              <Link to="/cadastro"               className="text-white/30 hover:text-white/70 text-xs transition-colors">Cadastrar</Link>
            </div>
          </div>
          <div className="border-t border-white/5 pt-5 flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-white/20 text-xs">© 2026 AcreJob · Rio Branco, Acre</p>
            <p className="text-white/20 text-xs">Conectando talentos e oportunidades no Acre</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
